import React from 'react';
import TicketModalForm from 'components/tickets-form/TicketModalForm';
import {
  arrayOf, bool, func, number, shape, string,
} from 'prop-types';

const Issue = ({
  ticketStatuses = [],
  ticketPriorities = [],
  ticketTypes = [],
  ticketCommitmentLevels = [],
  ticketDevStages = [],
  ticketDevStatuses = [],
  ticketSizes = [],
  ticketCwoModules = [],
  currentUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
    companyId: null,
  },
  responsibleUserInfo = {
    id: null,
    type: '',
    username: '',
    avatarUrl: '',
  },
  canCreateTicket = false,
  isModalOpen = false,
  setIsModalOpen,
}) => {
  if (!canCreateTicket) return null;

  return (
    <TicketModalForm
      currentUserInfo={currentUserInfo}
      statuses={ticketStatuses}
      priorities={ticketPriorities}
      ticketTypes={ticketTypes}
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      ticketFromDashboard={false}
      responsibleUserInfo={responsibleUserInfo}
      commitmentLevels={ticketCommitmentLevels}
      devStages={ticketDevStages}
      devStatuses={ticketDevStatuses}
      sizes={ticketSizes}
      cwoModules={ticketCwoModules}
    />
  );
};

Issue.propTypes = {
  currentUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
    companyId: number,
  }),
  ticketStatuses: arrayOf(string),
  ticketPriorities: arrayOf(string),
  ticketTypes: arrayOf(string),
  responsibleUserInfo: shape({
    id: number,
    type: string,
    username: string,
    avatarUrl: string,
  }),
  ticketCommitmentLevels: arrayOf(string),
  ticketDevStages: arrayOf(string),
  ticketDevStatuses: arrayOf(string),
  ticketSizes: arrayOf(string),
  ticketCwoModules: arrayOf(string),
  canCreateTicket: bool,
  isModalOpen: bool,
  setIsModalOpen: func.isRequired,
};

export default Issue;
